import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Slot } from './slot';
export { Slot };
import { slotSchema } from '@schemas/business-objects/slot';
import { ActivityAssignmentFormArray } from './activity-assignment-form-group';
import { AlternateStudentAvailabilityFormArray } from './alternate-student-availability-form-group';
import { StudentAssignmentFormArray } from './student-assignment-form-group';
import { TermTimeFormGroup } from './term-time-form-group';

export class SlotFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    dayOfWeek: SchemaFormControl;
    timeId: SchemaFormControl;
    time: TermTimeFormGroup;
    activityAssignments: ActivityAssignmentFormArray;
    studentAssignments: StudentAssignmentFormArray;
    alternateStudentAvailabilities: AlternateStudentAvailabilityFormArray;
  };

  declare value: Partial<Slot>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(slotSchema, Slot, data, options);
  }

  get object(): Slot {
    return new Slot(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'time':
        return new TermTimeFormGroup();
      case 'activityAssignments':
        return new ActivityAssignmentFormArray();
      case 'studentAssignments':
        return new StudentAssignmentFormArray();
      case 'alternateStudentAvailabilities':
        return new AlternateStudentAvailabilityFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Slot[]> {
    return Slot.find(filter);
  }

  static async findOne(filter?: any): Promise<Slot | null> {
    return Slot.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Slot> {
    return Slot.findById(id, filter);
  }

  static async create(data: Partial<Slot>): Promise<Slot> {
    return Slot.create(data as any);
  }

  static async updateById(id: number, updates: Partial<Slot>): Promise<Slot> {
    return Slot.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Slot.deleteById(id);
  }
}

export class SlotFormArray extends PersistedFormArray {
  readonly entityName = 'Slot' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(slotSchema, Slot, options);
  }

  protected override createItemGroup() {
    return new SlotFormGroup();
  }

  get array(): Slot[] {
    return this.controls.map((group: SlotFormGroup) => group.object);
  }
}

export class SlotPersistedArray extends PersistedArray<Slot> {
  readonly entityName = 'Slot' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Slot, options);
  }
}
